import React from 'react';
import "../LandingPage.css";
import { Card } from 'antd';

const CookiePage = () => {
  return (
    <div style={{ paddingLeft: "20px", paddingRight: "20px", paddingBottom: "60px", paddingTop: "60px" }}>
      <Card 
        style={{
          marginTop: "60px",
          marginBottom: "60px",
          maxWidth: 800,
          margin: "auto",
          minWidth: 280,
          textAlign: "left",
          boxShadow: "0 8px 16px rgba(0,0,0,0.1)"
        }}>
        <div style={{ padding: "20px", maxWidth: '800px', margin: '0 auto' }}>
          <h1>Informasjonskapsler</h1>
          <p>Sist oppdatert: 10. februar 2025</p>

          <h2>1. Innledning</h2>
          <p>
            Velkommen til Kipler ("Selskapet", "vi", "oss", "vår"). Vi bruker informasjonskapsler og lignende teknologier på vår nettside
            <a href="https://www.kipler.ai"> www.kipler.ai</a> for å forbedre brukeropplevelsen, analysere trafikk og støtte markedsføringsinitiativer. Denne policyen forklarer hva informasjonskapsler er, hvilke typer vi bruker, hvorfor vi bruker dem, og hvordan du kan administrere dine preferanser.
          </p>

          <h3>2. Hva er informasjonskapsler?</h3>
          <p>
            Informasjonskapsler er små tekstfiler som lagres på din enhet (datamaskin, nettbrett, smarttelefon) når du besøker et nettsted. De kan være "førsteparts" (satt av nettstedet du besøker) eller "tredjeparts" (satt av andre domener).
          </p>

          <h3>3. Typer informasjonskapsler vi bruker</h3>
          <ul>
            <li><strong>Nødvendige informasjonskapsler:</strong> Essensielle for at nettstedet skal fungere korrekt.</li>
            <li><strong>Ytelsesinformasjonskapsler:</strong> Samler anonym data om hvordan brukere navigerer på siden.</li>
            <li><strong>Funksjonalitetsinformasjonskapsler:</strong> Lagrer brukerpreferanser som språk og innloggingsdetaljer.</li>
            <li><strong>Målrettings-/annonseringskapsler:</strong> Brukes for å vise relevante annonser og begrense antall ganger en annonse vises.</li>
          </ul>

          <h3>4. Tredjeparts informasjonskapsler</h3>
          <p>
            I tillegg til våre egne informasjonskapsler, kan vi også bruke ulike tredjeparts informasjonskapsler for å rapportere bruksstatistikk for Nettstedet og levere annonser gjennom og via Nettstedet. For eksempel bruker vi Google Analytics for å samle inn og analysere informasjon om bruken av vårt Nettsted. Denne informasjonen hjelper oss med å forstå hvordan besøkende engasjerer seg med Nettstedet og forbedre brukeropplevelsen. For mer informasjon om Google Analytics-informasjonskapsler, besøk Google Analytics' nettside.
          </p>

          <h3>5. Administrasjon av informasjonskapsler</h3>
          <p>
            Du har rett til å bestemme om du vil akseptere eller avvise informasjonskapsler. Du kan utøve dine informasjonskapselpreferanser ved å klikke på de aktuelle avmeldingslenkene som er oppgitt nedenfor.
          </p>
          <p>
            Du kan sette eller endre nettleserinnstillingene dine til å akseptere eller avvise informasjonskapsler. Hvis du velger å avvise informasjonskapsler, kan du fortsatt bruke vårt Nettsted, selv om tilgangen din til noen funksjoner og områder på vårt Nettsted kan være begrenset. Siden måtene du kan avvise informasjonskapsler gjennom nettleserinnstillingene varierer fra nettleser til nettleser, bør du besøke nettleserens hjelpemeny for mer informasjon.
          </p>

          <h3>6. Endringer i denne policyen</h3>
          <p>
            Vi kan oppdatere denne informasjonskapselpolicyen fra tid til annen for å gjenspeile for eksempel endringer i informasjonskapslene vi bruker eller av andre operasjonelle, juridiske eller regulatoriske årsaker. Vennligst besøk denne informasjonskapselpolicyen regelmessig for å holde deg informert om vår bruk av informasjonskapsler og relaterte teknologier.
          </p>

          <h3>7. Kontakt oss</h3>
          <p>
            Hvis du har spørsmål om vår bruk av informasjonskapsler eller andre teknologier, vennligst send oss en e-post på:
          </p>
          <p>
            E-post: <a href="mailto:post@kipler.ai">post@kipler.ai</a><br />
            Adresse: Sverdrups gate 21, 0559 Oslo
          </p>
        </div>
      </Card>
    </div>
  );
};

export default CookiePage;